export default __webpack_public_path__ + "static/29-dadd8490d3c9dfb52418a63e9c4aa588.png";